import { render, staticRenderFns } from "./WelfarShare.vue?vue&type=template&id=6b5236ea&scoped=true&lang=html&"
import script from "./WelfarShare.vue?vue&type=script&lang=js&"
export * from "./WelfarShare.vue?vue&type=script&lang=js&"
import style0 from "./WelfarShare.vue?vue&type=style&index=0&id=6b5236ea&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b5236ea",
  null
  
)

export default component.exports